<template>
  <span>
    <v-card
      class="align-center pt-0"
      width="350"
      height="100%"
      :color="message.sender_type === 'self' ? '#e4e3e3' : 'messageBubble'"
      elevation="0"
    >
      <v-card-title class="pa-0 ma-0 my-1">
        <v-btn
          x-small
          outlined
          color="cleed_blue"
          v-show="message.content.step"
        >
          <b>
            {{
              store_config.i18n[$i18n.locale].chat[message.content.step] ||
              message.content.step
            }}
          </b>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-1">
        <v-row dense>
          <v-col
            class="ml-2 black--text"
            cols="12"
            v-if="message.content.message"
          >
            <span
              style="white-space: pre-wrap"
              v-html="
                translate(message.content.message) || message.content.message
              "
            />
          </v-col>
          <v-col cols="12" class="mb-0">
            <v-chip
              class="pa-2 ma-1 white--text"
              small
              label
              v-for="(chip, index) in message.content.buttons"
              :key="index"
              color="grey darken-3"
            >
              <b v-if="chip.name" v-html="translate(chip.name) || chip.name" />
              <b
                v-else-if="chip.value"
                v-html="
                  store_config.i18n[$i18n.locale].buttons
                    ? store_config.i18n[$i18n.locale].buttons[chip.value] ||
                      chip.value
                    : chip.value
                "
              />
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
export default {
  name: "Chat_buttons",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  computed: {
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  created() {},
  methods: {
    translate(steps) {
      const keys = steps.split(".");
      // console.log(keys);
      let result = this.store_config.i18n[this.$i18n.locale];
      for (let i = 0; i < keys.length; i++) {
        const element = keys[i];
        if (result[element]) result = result[element];
        else return null;
      }
      return result;
    },
  },
};
</script>
<style scoped></style>
